import * as React from "react";

import { PlotPanelContext } from "./PlotPanelContext";

export const usePlotPanelContext = () => {
  return React.useContext(PlotPanelContext);
};
